import React from 'react';

// Inline circular flags for the storefront countries. Windows doesn't render
// flag emoji (it shows "US"/"CO" letters), so these draw the same everywhere.
const FLAGS = {
  CO: (
    <>
      <rect width="24" height="12" fill="#FCD116" />
      <rect y="12" width="24" height="6" fill="#003893" />
      <rect y="18" width="24" height="6" fill="#CE1126" />
    </>
  ),
  US: (
    <>
      <rect width="24" height="24" fill="#fff" />
      {[0, 2, 4, 6, 8, 10, 12].map((i) => (
        <rect key={i} y={(i * 24) / 13} width="24" height={24 / 13} fill="#B22234" />
      ))}
      <rect width="11" height={(24 * 7) / 13} fill="#3C3B6E" />
      {[2.5, 5.5, 8.5].flatMap((x) => [2.2, 5, 7.8, 10.6].map((y) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="0.55" fill="#fff" />
      )))}
    </>
  ),
  MX: (
    <>
      <rect width="8" height="24" fill="#006847" />
      <rect x="8" width="8" height="24" fill="#fff" />
      <rect x="16" width="8" height="24" fill="#CE1126" />
      <circle cx="12" cy="12" r="2" fill="#8C6B2F" />
    </>
  ),
};

const getFlagEmoji = (code) =>
  String.fromCodePoint(...code.toUpperCase().split('').map((ch) => 127397 + ch.charCodeAt()));

const CountryFlag = ({ code, size = 24, className = '' }) => {
  const flag = FLAGS[(code || '').toUpperCase()];
  if (!flag) {
    return (
      <span aria-hidden="true" className={className} style={{ fontSize: size * 0.85, lineHeight: 1 }}>
        {getFlagEmoji(code || 'UN')}
      </span>
    );
  }
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={`shrink-0 rounded-full ${className}`}
      style={{ boxShadow: '0 0 0 1px rgba(0,0,0,0.12)' }}
    >
      <clipPath id={`flag-clip-${code}`}><circle cx="12" cy="12" r="12" /></clipPath>
      <g clipPath={`url(#flag-clip-${code})`}>{flag}</g>
    </svg>
  );
};

export default CountryFlag;
